import PropTypes from "prop-types";

export class ErrorHandle extends Error {
    constructor(props) {
        super();

        this.response = props.response
        this.text = props.text
    }
}

ErrorHandle.propsType = {
    text: PropTypes.object,
    response: PropTypes.object
}
